import React, { Component } from 'react'

export class MonitoringAcordion extends Component {
  state = { isOpen: true }

  toggle = () => {
    this.setState((oldState) => ({ isOpen: !oldState.isOpen }))
  }

  render() {
    return (
      <>
        <span className="accordionTitle" onClick={this.toggle}>
          {this.props.title}
          <span className={this.state.isOpen ? 'fas fa-caret-right' : 'fas fa-caret-down'} />
        </span>
        {this.state.isOpen && this.props.children}
      </>
    )
  }
}
